export default __webpack_public_path__ + "static/media/98-10_header_invoice.e793dd75.png";